webpackJsonp([38187647151852],{

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(66);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactstrap = __webpack_require__(17);
	
	var _gatsbyImage = __webpack_require__(22);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _EventsModule = __webpack_require__(65);
	
	var _EventsModule2 = _interopRequireDefault(_EventsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Events = function Events(_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _EventsModule2.default.jumbo },
	    _react2.default.createElement(
	      'div',
	      { className: 'h-100 w-100 ' + _EventsModule2.default.content },
	      _react2.default.createElement(
	        _reactstrap.Container,
	        null,
	        _react2.default.createElement(
	          _reactstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Col,
	            {
	              md: { size: 6, offset: 3 },
	              sm: { size: 8, offset: 2 },
	              className: 'text-center'
	            },
	            _react2.default.createElement(
	              'h2',
	              { className: 'text-light' },
	              'Events & Functions'
	            ),
	            _react2.default.createElement('hr', { className: 'bg-light' }),
	            _react2.default.createElement(
	              'p',
	              { className: 'text-light' },
	              'We offer multiple private areas for events & functions.'
	            ),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/contact' },
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { outline: true, color: 'primary' },
	                'Book An Event'
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_gatsbyImage2.default, {
	      sizes: data.childImageSharp.sizes,
	      style: {
	        width: "100%",
	        height: "100%"
	      }
	    })
	  );
	};
	
	exports.default = Events;
	module.exports = exports['default'];

/***/ }),

/***/ 65:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"jumbo":"src-components----Events-module---jumbo---lKice","content":"src-components----Events-module---content---19dyn"};

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(17);
	
	var _gatsbyImage = __webpack_require__(22);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _HeaderModule = __webpack_require__(401);
	
	var _HeaderModule2 = _interopRequireDefault(_HeaderModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// ToDo: Vertically center Jumbotron
	var Header = function Header(_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _HeaderModule2.default.jumbo },
	    _react2.default.createElement(
	      'div',
	      { className: 'h-100 w-100 ' + _HeaderModule2.default.content },
	      _react2.default.createElement(
	        _reactstrap.Container,
	        null,
	        _react2.default.createElement(
	          _reactstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Col,
	            {
	              md: { size: 6, offset: 3 },
	              sm: { size: 8, offset: 2 },
	              className: 'text-center'
	            },
	            _react2.default.createElement(
	              'h1',
	              { className: 'text-light' },
	              'Drinks Menu'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'text-light lead' },
	              'This is the drinks menu'
	            ),
	            _react2.default.createElement('hr', { className: 'bg-light' }),
	            _react2.default.createElement(
	              'p',
	              { className: 'text-light' },
	              'Browse our wide selection of drinks...'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_gatsbyImage2.default, {
	      sizes: data.childImageSharp.sizes,
	      style: {
	        width: "100%",
	        height: "100%"
	      }
	    })
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 401:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"jumbo":"src-components-drinks----Header-module---jumbo---3_-8u","content":"src-components-drinks----Header-module---content---281Rh"};

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(22);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactstrap = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Menu = function Menu(_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(
	    _reactstrap.Container,
	    null,
	    _react2.default.createElement(
	      _reactstrap.Row,
	      { className: 'my-5' },
	      _react2.default.createElement(
	        _reactstrap.Col,
	        { md: 6 },
	        _react2.default.createElement(
	          'h2',
	          { className: 'text-center' },
	          'Drinks'
	        ),
	        _react2.default.createElement('hr', { className: 'bg-primary w-75' }),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Maecenas malesuada varius arcu, at molestie enim pharetra a. Curabitur vitae tristique dui. Etiam congue elementum turpis non dignissim. Fusce dictum nunc placerat, varius diam eget, imperdiet sem. Donec laoreet convallis magna, et lobortis metus accumsan eget.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Sed eget erat non libero pulvinar vulputate. Donec in posuere turpis, in euismod diam. Sed.'
	        )
	      ),
	      _react2.default.createElement(
	        _reactstrap.Col,
	        { md: 6 },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          outerWrapperClassName: 'h-100',
	          sizes: data.childImageSharp.sizes,
	          style: {
	            height: "100%"
	          }
	        })
	      )
	    )
	  );
	};
	
	exports.default = Menu;
	module.exports = exports['default'];

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(290);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Menu = __webpack_require__(291);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Events = __webpack_require__(56);
	
	var _Events2 = _interopRequireDefault(_Events);
	
	var _ContactAndMap = __webpack_require__(76);
	
	var _ContactAndMap2 = _interopRequireDefault(_ContactAndMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Drinks = function Drinks(_ref) {
	  var data = _ref.data;
	  var mainImage = data.mainImage,
	      eventsImage = data.eventsImage,
	      drinksImage = data.drinksImage;
	
	
	  return _react2.default.createElement(
	    'div',
	    { id: 'top', style: { marginTop: '63px' } },
	    _react2.default.createElement(_Header2.default, { data: mainImage }),
	    _react2.default.createElement(_Menu2.default, { data: drinksImage }),
	    _react2.default.createElement(_Events2.default, { data: eventsImage }),
	    _react2.default.createElement(_ContactAndMap2.default, null)
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = Drinks;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-drinks-js-4865271a73d4ca0c2e36.js